import type { CepProps } from "../types/cep";

export class CepNotFoundError extends Error {
	constructor(message = "CEP informado inválido!") {
		super(message);
		this.name = "CepNotFoundError";
	}
}

export async function getAddressByCep(cep: string): Promise<CepProps> {
	const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
	const data = await response.json();

	if (JSON.stringify(data).indexOf("erro") > -1) {
		throw new CepNotFoundError();
	}

	return data as CepProps;
}
